var map = {
	"./banner.jpg": "301c",
	"./banner.png": "1936",
	"./bg_white.png": "c3c5",
	"./bonus_pc_en.png": "510d",
	"./bonus_pc_id.png": "8c65",
	"./bonus_pc_km.png": "7d61",
	"./bonus_pc_pt.png": "22c5",
	"./bonus_pc_th.png": "4e68",
	"./bonus_pc_usdt.png": "3519",
	"./bonus_pc_yn.png": "58a4",
	"./bonus_pc_zh.png": "7063",
	"./bonus_phone_en.png": "86bf",
	"./bonus_phone_id.png": "7c82",
	"./bonus_phone_km.png": "cd36",
	"./bonus_phone_pt.png": "6675",
	"./bonus_phone_th.png": "140b",
	"./bonus_phone_usdt.png": "6ca1e",
	"./bonus_phone_yn.png": "8d15",
	"./bonus_phone_zh.png": "7754",
	"./flag_Indonesia.png": "477d",
	"./flag_Vietnamese.png": "0358",
	"./flag_america.png": "b200",
	"./flag_brazil.png": "34dc",
	"./flag_cambodia.png": "d9c5",
	"./flag_china.png": "0beb",
	"./flag_thai.png": "c014",
	"./game_pc_en.png": "c3ea",
	"./game_pc_id.png": "fdc4",
	"./game_pc_km.png": "04d2",
	"./game_pc_pt.png": "be0c",
	"./game_pc_th.png": "2114",
	"./game_pc_yn.png": "e8b2",
	"./game_pc_zh.png": "4f75",
	"./game_phone_en.png": "c534",
	"./game_phone_id.png": "9976",
	"./game_phone_km.png": "8287",
	"./game_phone_pt.png": "4559",
	"./game_phone_th.png": "5695",
	"./game_phone_usdt.png": "a1b1",
	"./game_phone_yn.png": "f0ac",
	"./game_phone_zh.png": "45e9",
	"./img_concern.png": "fb93",
	"./img_prize.png": "a47e",
	"./img_prize1.png": "bd06",
	"./img_red.png": "52e0",
	"./line.png": "fe82",
	"./quiz_bg.jpg": "e3f4",
	"./quiz_bg_01.png": "c95b",
	"./quiz_bg_02.png": "fc6e",
	"./vipprivileges_km.png": "71c6",
	"./vipprivileges_th.png": "04e3",
	"./vipprivileges_zh.png": "6b21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";